
import {Api} from "../../src/Api";
import {mapState} from 'vuex';
import {State} from 'modules/spravochnik/dt-front-page-generator/store';

export default {
    computed: mapState({
        data: (state: State) => state.openData.data
    }),
    async mounted() {
        this.loading = true;
        await this.$store.dispatch('openData/loadOpenDataCategories');
        this.loading = false;
    },
    data() {
        return {
            loading: true,
        }
    }
};
